<section
  class="carousel-container"
  *ngIf="images.length > 0"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    class="carousel"
  >
    <div
      class="carousel-slides-container"
      fxLayout="column"
      fxLayoutAlign="center center"
      (swipeleft)="getNext()"
      (swiperight)="getPrevious()"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutAlign.gt-sm="end start"
        class="container content over"
        [routerLink]="[basePath, 'contacteaza-ne']"
      >
        <div
          class="info-box"
          [ngClass]="{'animation1': animateTitle, 'animation2': !animateTitle}"
        >
          <div class="phase-highlight">
            <span class="phase-label">Start Vânzări!</span>
            <h1 class="main-title">Faza 3B — Clădire Nouă</h1>
            <p class="phase-description">Pregătim lansarea unei noi clădiri în faza 3B. Detalii în curând!</p>
          </div>

          <div class="phases-list">
            <div class="phase-item phase-active">
              <span class="phase-name">Faza 3B · Clădirea J </span>
              <span class="phase-status"> 60% vândută · ultimele apartamente disponibile!</span>
            </div>
            <div class="phase-item phase-sold">
              <span class="phase-name">Faza 3A</span>
              <span class="phase-status">100% vândută</span>
            </div>
            <div class="phase-item phase-sold">
              <span class="phase-name">Faza 2</span>
              <span class="phase-status">100% vândută</span>
            </div>
            <div class="phase-item phase-sold">
              <span class="phase-name">Faza 1</span>
              <span class="phase-status">100% vândută</span>
            </div>
          </div>

          <a
            fxHide
            fxShow.gt-sm
            [routerLink]="[basePath, 'contacteaza-ne']"
            mat-raised-button
            color="transparent"
            class="search-link"
          >
            {{ 'shared.menu_links.contact' | translate }}
          </a>
        </div>
      </div>
      <div
        *ngFor="let image of images; let i = index"
        [ngStyle]="{'background-image': 'url(' + image.url + ')'}"
        [ngClass]="{'current-slide': i === currentSlideNumber, 'hidden-slide': i != currentSlideNumber}"
        class="content"
      >
      </div>
      <button
        *ngIf="images.length > 1"
        mat-button
        (click)="animateTitle = !animateTitle;getPrevious($event)"
        style="background-image: url('/assets/icons/shapes/arrows/main/left.svg')"
        class="left-arrow"
      >
      </button>
      <button
        *ngIf="images.length > 1"
        mat-button
        (click)="animateTitle = !animateTitle;getNext($event)"
        style="background-image: url('/assets/icons/shapes/arrows/main/right.svg')"
        class="right-arrow"
      >
      </button>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/shared/components/homepage-carousel/homepage-carousel.component.html